import { createSlice } from '@reduxjs/toolkit';
import {
  submitReviewRequestThunk,
  fetchMyReviewRequestsThunk,
  fetchAdminReviewQueueThunk,
  decideReviewRequestThunk,
} from './contentReviewActionThunks';

const initialState = {
  mine: [],
  adminQueue: [],
  loading: { mine: false, adminQueue: false, submit: false, decide: false },
  errors: { mine: null, adminQueue: null, submit: null, decide: null },
};

const contentReviewSlice = createSlice({
  name: 'contentReview',
  initialState,
  reducers: {
    clearSubmitError: (state) => {
      state.errors.submit = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Submit
      .addCase(submitReviewRequestThunk.pending, (state) => {
        state.loading.submit = true;
        state.errors.submit = null;
      })
      .addCase(submitReviewRequestThunk.fulfilled, (state, action) => {
        state.loading.submit = false;
        state.mine.unshift(action.payload);
      })
      .addCase(submitReviewRequestThunk.rejected, (state, action) => {
        state.loading.submit = false;
        state.errors.submit = action.payload || 'Failed to submit review request';
      })

      // Mine
      .addCase(fetchMyReviewRequestsThunk.pending, (state) => {
        state.loading.mine = true;
        state.errors.mine = null;
      })
      .addCase(fetchMyReviewRequestsThunk.fulfilled, (state, action) => {
        state.loading.mine = false;
        state.mine = action.payload;
      })
      .addCase(fetchMyReviewRequestsThunk.rejected, (state, action) => {
        state.loading.mine = false;
        state.errors.mine = action.payload || 'Failed to load your review requests';
      })

      // Admin queue
      .addCase(fetchAdminReviewQueueThunk.pending, (state) => {
        state.loading.adminQueue = true;
        state.errors.adminQueue = null;
      })
      .addCase(fetchAdminReviewQueueThunk.fulfilled, (state, action) => {
        state.loading.adminQueue = false;
        state.adminQueue = action.payload;
      })
      .addCase(fetchAdminReviewQueueThunk.rejected, (state, action) => {
        state.loading.adminQueue = false;
        state.errors.adminQueue = action.payload || 'Failed to load the review queue';
      })

      // Decide
      .addCase(decideReviewRequestThunk.pending, (state) => {
        state.loading.decide = true;
        state.errors.decide = null;
      })
      .addCase(decideReviewRequestThunk.fulfilled, (state, action) => {
        state.loading.decide = false;
        state.adminQueue = state.adminQueue.filter((r) => r.id !== action.payload.id);
      })
      .addCase(decideReviewRequestThunk.rejected, (state, action) => {
        state.loading.decide = false;
        state.errors.decide = action.payload || 'Failed to record the decision';
      });
  },
});

export const { clearSubmitError } = contentReviewSlice.actions;
export default contentReviewSlice.reducer;
